import { animate, query, stagger, style, transition, trigger } from '@angular/animations';

// Per-bar fill duration. Stagger is set to the same value so bar N+1 begins
// the moment bar N finishes — to the eye it reads as one continuous progress
// sweep across the segmented track (gap-pauses aside). Linear easing keeps
// the perceived rate uniform across segments. In-flow single-bar fills are
// :enter sets of size 1, so stagger has nothing to stagger across and the
// new bar fills in BAR_FILL_MS without artificial delay.
const BAR_FILL_MS = 1000;

export const stepperFillAnimation = trigger('stepperFill', [
  transition('* => *', [
    query(':enter > span', [
      style({ transform: 'scaleX(0)' }),
      stagger(`${BAR_FILL_MS}ms`, [
        animate(`${BAR_FILL_MS}ms linear`, style({ transform: 'scaleX(1)' })),
      ]),
    ], { optional: true }),
  ]),
]);
